import { connect } from 'react-redux';
import ProductManagement from '../components/product-sales/ProductManagement';

const mapStateToProps = state => ({
  auth: state.auth,
  user: state.user,
  admin: state.admin,
});

const mapDispatchToProps = dispatch => ({
  // Add actions here when needed
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductManagement);
